<ng-template #modal>
  <div class="modal-header">
    <svg class="icon icon-warning me-1">
      <use href="assets/icons/sprites.svg#it-error"></use>
    </svg>
    <h2 class="modal-title h5" id="modal3Title">
      {{ modalConfig.modalTitle }}
    </h2>

    <!-- <div class=" with-icon warning" role="alert">
        <h5 class="modal-title "><svg class="icon me-2"><use href="assets/icons/sprites.svg#it-error"></use></svg>{{ modalConfig.modalTitle }}</h5>
      </div> -->
    <!-- <h5 class=""></h5> -->
  </div>
  <div class="modal-body">
    <ng-content></ng-content>
  </div>
  <div class="d-inline-flex justify-content-between modal-footer">

    <div class="d-flex justify-content-start ">
      <input 
            id="disclaimercheck" 
            type="checkbox" 
            (change)="checked()"
            *ngIf="
            modalConfig.hideCheckBox === undefined ||
            !modalConfig.hideCheckBox()
          "
          [disabled]="
            modalConfig.disableCheckBox !== undefined &&
            modalConfig.disableCheckBox()
          "
      >
      <label for="" class="" 
      *ngIf="
      modalConfig.hideCheckBox === undefined ||
      !modalConfig.hideCheckBox()
    ">Ho letto e compreso le condizioni d'uso del sistema</label>
    </div>

    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="dismiss()"
      *ngIf="
        modalConfig.hideDismissButton === undefined ||
        !modalConfig.hideDismissButton()
      "
      [disabled]="
        modalConfig.disableDismissButton !== undefined &&
        modalConfig.disableDismissButton()
      "
    >
      {{ modalConfig.dismissButtonLabel }}
    </button>
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="close()"
      *ngIf="
        modalConfig.hideCloseButton === undefined ||
        !modalConfig.hideCloseButton()
      "
      [disabled]="
        modalConfig.disableCloseButton !== undefined &&
        modalConfig.disableCloseButton()
      "
    >
      {{ modalConfig.closeButtonLabel }}
    </button>




  <!-- <div class="d-inline-flex justify-content-between modal-footer">
    <div class="col-lg-8 col-md-6 col-sm-8">
      <div class="d-flex justify-content-start ">
        <input id="disclaimercheck" type="checkbox" (change)="checked()">
        <label for="" class="">ho letto e compreso le condizioni d'uso del sistema</label>
      </div>
    </div>
    <button class="col-lg-4 col-md-6 col-sm-4"
      type="button"
      class="btn btn-outline-primary"
      (click)="dismiss()"
      [disabled]="!disclaimerChecked"
    >
      {{ modalConfig.dismissButtonLabel }}
    </button> -->
  </div>
</ng-template>
